import { getMiddlePosition } from "../../../../utils";
export const getBreakLinePositions = (points) => {
    const breakLinePositions = [];
    for (let i = 0; i < points.length - 1; i++) {
        breakLinePositions.push(getMiddlePosition(points[i], points[i + 1]));
    }
    return breakLinePositions;
};
